module.exports = __webpack_public_path__ + "assets/img/weight_open.e83755f0.svg";